import { QRFC } from "./QRFC";

export class QSyncPlanRFC extends QRFC {
  constructor() {
    super();
  }

  InitSyncPlanRFC(callbackObj) {
    this.fWSMgr = callbackObj.fWSMgr;
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "planning/qplanrfc";
  }

  SetParams(orgName, userName, data) {
    this.AddParameter("org", orgName);
    this.AddParameter("user", userName);
    this.AddParameter("data", data);
    this.AddParameter("mode", "doPlanSync");
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    var success = r["success"];
    if (callBackObj.fWaiting) {
      callBackObj.ClearAppLoadingAnimation();
      callBackObj.fWaiting = null;
    }
    if (success) {
      callBackObj.OpenPlan(r["id"]);
      var planMgr = callBackObj.fPlanManager;
      planMgr.SimulateSaveFeedback();
    }
  }
}
